import React, { ReactNode, useContext } from 'react';
import { AppContext } from '../../../common/context/Provider';

interface Props {
    isOpen: boolean;
    modalTitle: string;
    onClose: () => void;
    onSubmit: () => void;
    children: ReactNode;
    disableSubmit?: boolean;
    zindex?: number;
    widthCustom?: string;
}

export const Modal = ({
    isOpen,
    modalTitle,
    onClose,
    onSubmit,
    children,
    disableSubmit,
    zindex = 99999,
    widthCustom = '1010px',
}: Props) => {
    const { langResources, isSkinSmart } = useContext(AppContext);

    return (
        <div
            className='modal pt-5'
            style={{
                display: isOpen ? 'block' : 'none',
                background: 'rgba(0,0,0,0.5)',
                zIndex: zindex,
            }}
        >
            <div
                id='modal-base'
                className='modal-dialog rounded w-100 mt-5'
                style={{
                    width: !widthCustom ? '1010px' : widthCustom,
                    maxWidth: !widthCustom ? '1010px' : widthCustom,
                }}
            >
                <div className='modal-content mt-5'>
                    <div className='modal-header'>
                        <div className='modal-header d-flex justify-content-between w-100 p-0'>
                            <h5 className={`modal-title `}>{modalTitle}</h5>
                            <button
                                type='button'
                                className='btn-close'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                                onClick={onClose}
                            ></button>
                        </div>
                    </div>

                    <div className='modal-body py-1'>
                        <div className=''>{children}</div>
                    </div>

                    <div className='modal-footer'>
                        <button
                            type='button'
                            className={`btn btn-primary`}
                            onClick={onSubmit}
                            disabled={disableSubmit}
                        >
                            {langResources['basemodal.save.button']}
                        </button>
                        <button
                            type='button'
                            className='btn btn-light'
                            onClick={onClose}
                            data-bs-dismiss='modal'
                        >
                            {langResources['basemoda.cancel.button']}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
